(function (module) {
    "use strict";

    module.component('volumeToValueTranslation', {
        template: require('./volumeToValueTranslationComponent.html'),
        bindings: {
            priceChangeStartDate: '<',
            priceChangeEndDate: '<',
            currency: '<',
            yearlyAveragePrice: '=',
            priceChangeInYears: '=',
            onChange: "&"
        },
        controller: ['$scope', 'volumeToValueService',
            function(this: $TSFixMe, $scope: $TSFixMe, volumeToValueService: $TSFixMe) {
                var $ctrl = this;

                function prepareForecastData() {
                    initializeGridIfRequried();
                    recalculateValue();
                }

                function recalculateValue() {

                    if (angular.isUndefinedOrNull($ctrl.priceChangeInYears))
                        return;

                    $ctrl.onChange && $ctrl.onChange({forecast: $ctrl.forecast, parameters: $ctrl.parameters});
                }

                function calculateFooterData(historicalValue: $TSFixMe, priceChangesInYears: $TSFixMe) {
                    
                    const averagePrices = volumeToValueService.calculateAveragePrices(_.last(historicalValue), priceChangesInYears);
                    return { values: [...historicalValue, ...averagePrices] };
                }

                function initializeGridIfRequried() {
                    
                    let historicalAveragePriceDateStart = moment.utc($ctrl.yearlyAveragePrice[0].year, 'YYYY').toDate(),
                        
                        historicalAveragePriceDateEnd = moment.utc($ctrl.yearlyAveragePrice[$ctrl.yearlyAveragePrice.length - 1]),
                        
                        historicalAveragePriceYears = _.range(moment(historicalAveragePriceDateStart).get('year'), moment(historicalAveragePriceDateEnd).get('year') + 1);

                    let footerDatayearlyAveragePrice = $ctrl.yearlyAveragePrice.map((x: $TSFixMe) => x.averagePrice);

                    $ctrl.averagePriceForecastOptions = {
                        gridName: "averagePriceForecast",
                        
                        header: historicalAveragePriceYears.concat(_.range(moment($ctrl.priceChangeStartDate).get('year'), moment($ctrl.priceChangeEndDate).get('year') + 1)),
                        readOnlyCells: $ctrl.yearlyAveragePrice.length,
                        showFooter: true,
                        footerData: calculateFooterData(footerDatayearlyAveragePrice, $ctrl.priceChangeInYears),
                        fotterSpecialEnd: $ctrl.currency,
                        valuesSpecialEnd: '%',
                        allowNegative: true,
                        valuesDecimalPlaces: 1,
                        updateCell: function (input: $TSFixMe, idx: $TSFixMe, element: $TSFixMe) {
                            $ctrl.priceChangeInYears[idx - $ctrl.yearlyAveragePrice.length] = parseFloat(input);
                            $ctrl.recalculateAveragePriceForecastFooter();
                            $ctrl.onChange && $ctrl.onChange();
                        }
                    };

                    const percDiff = (curr: $TSFixMe, prev: $TSFixMe) => Math.round((curr - prev) / curr * 100);

                    let dataToGridValueEditor = [];

                    dataToGridValueEditor.push({
                        historicalValues: $ctrl.yearlyAveragePrice
                            .map((x: $TSFixMe) => x.averagePrice)
                            .map((val: $TSFixMe, i: $TSFixMe, arr: $TSFixMe) => percDiff(val, arr[i - 1] ? arr[i - 1] : val)),
                        values: $ctrl.priceChangeInYears,
                        header: "{{ 'FORECAST.VOLUME_TO_VALUE.PRICE_CHANGE' | translate}}"
                    });

                    $ctrl.averagePriceForecastOptions.gridData = dataToGridValueEditor;

                    $ctrl.recalculateAveragePriceForecastFooter = () => {
                        $scope.$apply(() => {
                            $ctrl.averagePriceForecastOptions.footerData = calculateFooterData(footerDatayearlyAveragePrice, $ctrl.priceChangeInYears);
                        });
                    };
                }

                $scope.$watchGroup(['$ctrl.priceChangeStartDate', '$ctrl.priceChangeEndDate', '$ctrl.yearlyAveragePrice', '$ctrl.priceChangeInYears'], function () {

                    if (angular.isUndefinedOrNull($ctrl.priceChangeStartDate)

                        || angular.isUndefinedOrNull($ctrl.priceChangeEndDate)

                        || angular.isUndefinedOrNull($ctrl.yearlyAveragePrice)

                        || angular.isUndefinedOrNull($ctrl.priceChangeInYears))
                        return;

                    
                    $ctrl.startYear = parseInt(moment($ctrl.priceChangeStartDate).format('YYYY'));
                    
                    $ctrl.endYear = parseInt(moment($ctrl.priceChangeEndDate).format('YYYY'));

                    prepareForecastData();
                });


            }]
    });

})(angular.module('topline.modules'));
